import PropTypes from 'prop-types';
import { ROOM_SETTINGS_PAGES } from '../../../../../constants/roomSettings';
import './SideBar.css';

const SideBar = ({
  currentPage = ROOM_SETTINGS_PAGES.SECURITY,
  onPageChange = () => {},
}) => {
  return (
    <div className="room-settings-sidebar">
      <button
        className={`room-settings-sidebar-button ${currentPage === ROOM_SETTINGS_PAGES.SECURITY ? 'active' : ''}`}
        onClick={() => onPageChange(ROOM_SETTINGS_PAGES.SECURITY)}
      >
        <ion-icon name="shield-checkmark-outline" />
        <span>Security & Privacy</span>
      </button>
      <button
        className={`room-settings-sidebar-button ${currentPage === ROOM_SETTINGS_PAGES.PERMISSIONS ? 'active' : ''}`}
        onClick={() => onPageChange(ROOM_SETTINGS_PAGES.PERMISSIONS)}
      >
        <ion-icon name="people-outline" />
        <span>Roles & Permissions</span>
      </button>
      <button
        className={`room-settings-sidebar-button ${currentPage === ROOM_SETTINGS_PAGES.NOTIFICATIONS ? 'active' : ''}`}
        onClick={() => onPageChange(ROOM_SETTINGS_PAGES.NOTIFICATIONS)}
      >
        <ion-icon name="notifications-outline" />
        <span>Notifications</span>
      </button>
    </div>
  );
};

SideBar.propTypes = {
  currentPage: PropTypes.string,
  onPageChange: PropTypes.func,
};

export default SideBar;
